<script>
import { BFormInput } from "bootstrap-vue";
import { IconMagnifyingGlass } from "@/components/icons/index";

export default {
  name: "AppButtonSearch",

  components: {
    BFormInput,
    IconMagnifyingGlass,
  },

  props: {
    value: { type: String, default: "" },
  },
};
</script>

<template>
  <div class="search-box">
    <div class="position-relative">
      <b-form-input
        v-on="$listeners"
        v-bind="$attrs"
        :value="value"
        type="search"
        class="form-control bg-light border-light rounded"
        placeholder="Search here"
      ></b-form-input>
      <IconMagnifyingGlass />
      <!-- <button
        v-if="value"
        type="button"
        aria-label="Close"
        class="close"
        @click="$emit('clear')"
      >
        ×
      </button> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-box {
  width: 315px;

  svg {
    position: absolute;
    left: 13px;
    top: 0;
    height: 38px;
  }

  input {
    &:hover,
    &:focus,
    &:active {
      outline: 1px solid #ced4da;
      border-radius: 4px;
    }
  }
}

.close {
  background: transparent;
  border: 0;
  font-size: 25px;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2;
  padding: 0 1.75rem !important;
  height: 100% !important;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  cursor: pointer;
}

// input[type="search"]::-webkit-search-decoration,
// input[type="search"]::-webkit-search-cancel-button,
// input[type="search"]::-webkit-search-results-button,
// input[type="search"]::-webkit-search-results-decoration {
//   -webkit-appearance: none;
// }
</style>
